import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AppConstants } from 'src/app/shared/app.constants';
import { AppUtils } from 'src/app/shared/app.utils';
import { UtcToLocalPipe } from 'src/app/shared/pipes/utc-to-local.pipe';

@Component({
  selector: 'ness-links-hits',
  templateUrl: './links-hits.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinksHitsComponent {
  @Input() crimeGunNumber: string = '';
  private _linkedHitsData: ServerModels.LinkedHitsViewModel[] = [];
  get linkedHitsData(): ServerModels.LinkedHitsViewModel[] {
    return this._linkedHitsData;
  }
  @Input() set linkedHitsData(hits: ServerModels.LinkedHitsViewModel[]) {
    this._linkedHitsData = hits;
    if (hits && !!hits.length) {
      this.prepareOnetoOneTableData();
    }
  }
  @Output() closeForm = new EventEmitter();
  @ViewChild(Table, { static: false }) dataTable: Table;
  cols: any[] = [
    { field: 'RefSiteCodeShortName', header: 'Site Code' },
    { field: 'RefLabCaseNumber', header: 'NIBIN Case/Exhibit #' },
    { field: 'TestSiteCodeShortName', header: 'Site Code' },
    { field: 'TestLabCaseNumber', header: 'NIBIN Case/Exhibit #' },
    { field: 'CreatedTime', header: 'Created Date' },
    { field: 'CreationUser', header: 'Created By' },
    { field: 'ConfirmationDate', header: 'Confirmation Date' },
    { field: 'ConfirmationUser', header: 'Confirmed By' },
    { field: 'Comment', header: 'Comments' },
    { field: 'Deleted', header: 'Deleted Lead' }
  ];
  rows: number = AppConstants.defaultTableRows;
  selectedHitsData: ServerModels.LinkedHitsViewModel[] = [];


  public exportCSV(options?: any) {
    const fn: string = `CrimeGun-${this.crimeGunNumber}-1to1NIBINLeadsHits.csv`;
    AppUtils.exportCSV(AppUtils.createCSVString({ dataTable: this.dataTable, columns: this.cols, selectionOnly: (options && options.selectionOnly), csvSeparator: ',', exportFunction: this.prepareExportData }), {
      fileName: fn
    });
  }

  public prepareExportData(cellData: any): string {
    if (cellData.field == 'CreatedTime' || cellData == 'ConfirmationDate') {
      let pipeTransform: UtcToLocalPipe = new UtcToLocalPipe();
      const receptionDate = pipeTransform.transform(cellData.data, 'MM/dd/yyyy ');
      return receptionDate;
    }

    if (cellData.field == 'RefLabCaseNumber') {
      return cellData.data;
    }

    return cellData.data;
  }

  private prepareOnetoOneTableData() {

    const hits = this._linkedHitsData.map(hit => {
      return {
        RefSiteCodeShortName: hit.RefSiteCodeShortName,
        RefExhibitReferenceNumber: hit.RefExhibitReferenceNumber,
        RefLabCaseNumber: `${hit.RefLabCaseNumber}/${hit.RefExhibitReferenceNumber}`,
        TestExhibitReferenceNumber: hit.TestExhibitReferenceNumber,
        TestSiteCodeShortName: hit.TestSiteCodeShortName,
        TestLabCaseNumber: `${hit.TestLabCaseNumber}/${hit.TestExhibitReferenceNumber}`,
        CreatedTime: hit.CreatedTime,
        CreationUser: hit.CreationUser,
        ConfirmationDate: hit.ConfirmationDate,
        ConfirmationUser: hit.ConfirmationUser,
        Comment: hit.Comment,
        Deleted: hit.Deleted
      } as ServerModels.LinkedHitsViewModel;
    });

    this._linkedHitsData = [...hits];
  }
}
